<label
  nz-checkbox
  class="checkbox"
  [ngStyle]="{
    gap: gap(),
    'font-size': fontSize(),
    'font-weight': fontWeight(),
    'line-height': lineHeight()
  }"
  [nzDisabled]="disabled()"
  [nzChecked]="value()"
  [nzIndeterminate]="indeterminate()"
  (nzCheckedChange)="onCheckboxChange($event)"
  ><ng-content
/></label>
